<template>
  <v-form @submit.prevent="addUpdate" ref="form">
    <v-card dense class="rounded-4">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">{{mode}} Leave Type</span>
            <v-spacer></v-spacer>
            <help-link appId="settings" pageId="leave-types-create" color="black"></help-link> 
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>      
            <v-layout row wrap>
                <v-flex xs12 sm12 style="padding:0px 25px 0px 25px;" >

                    <v-text-field label="Code" 
                        v-model="leave_type.leaveCode" 
                        :rules="[rules.required]" 
                        :disabled="disabled"
                        maxlength="5"
                        hint="Max 5 characters"
                        @keyup="error=false"></v-text-field> 
                    
                    <v-text-field label="Name" 
                        v-model="leave_type.leaveName" 
                        :rules="[rules.required]" 
                        :disabled="disabled"
                        maxlength="100"
                        @keyup="error=false"></v-text-field> 

                    <v-text-field label="Description" 
                        v-model="leave_type.leaveDescription" 
                        :rules="[rules.required]" 
                        :disabled="disabled"
                        maxlength="1000"
                        @keyup="error=false"></v-text-field> 
                </v-flex>

            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="clearForm" v-if="mode=='Add'" :disabled="disabled">Clear</v-btn>
            <v-btn color="primary" type="submit" :loading="loading" dark class="mr-25">Save</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import leaveTypesApi from '@/api/leavetypes'

export default {
    name: 'login-dialog',
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            disabled: false,
            error: false,       
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
            },
            mode: '',
            leave_type: {
                leaveTypeId: 0,
                leaveCode: null,
                leaveName: null,
                leaveDescription: null
            }
        }
    },
    methods: {
        setParamsAdd(){
            this.mode = 'Add'
            this.clearForm()
        },
        setParamsEdit(data){
            this.clearForm()
            this.mode = 'Edit'
            this.leave_type.leaveTypeId = data.leaveTypeId
            this.leave_type.leaveCode = data.leaveCode
            this.leave_type.leaveName = data.leaveName
            this.leave_type.leaveDescription = data.leaveDescription
        },
        closeDialog() {
            this.$emit('update:dialogAddEdit', false)
            this.clearForm()
        },
        async addUpdate() {
            if (this.$refs.form.validate()) {
                try{
                    this.loading = true
                    this.disabled = true
                    
                    var response = null
                    if (this.mode == 'Add')
                        response = await leaveTypesApi.add(this.leave_type)
                    else
                        response = await leaveTypesApi.update(this.leave_type)

                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false
                        this.closeDialog()
                        this.$emit('send', '')
                    }
                }catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
    computed: {
    },
    created() {
    }
}
</script>